const DEVICE_FP_KEY = "lsmy_device_fp";
const TEM_TOKEN_KEY = "lsmy_tem_token";
const TEM_AUTH_API_PREFIX = "/temAuthApi";
const GRANT_URL = "/gateway/auth/temToken/grant";
const SUCCESS_CODES = [true, "true", 1, "1", 0, "0", 200, "200", "S20000"];
const EXTRA_RETRYABLE_KEYWORDS = [
  "\u65e0\u6548\u6216\u5df2\u8fc7\u671f",
  "\u6821\u9a8c\u5931\u8d25",
  "\u5ba2\u6237\u7aef\u4fe1\u606f\u6821\u9a8c\u5931\u8d25"
];
const RETRYABLE_KEYWORDS = ["无效或已过期", "校验失败"];

let grantPromise = null;

function simpleHash(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
    hash = hash >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
}

function generateDeviceFp() {
  return simpleHash([
    navigator.userAgent,
    navigator.language,
    `${screen.width}x${screen.height}`,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 0
  ].join("|"));
}

export function getDeviceFp() {
  let fp = sessionStorage.getItem(DEVICE_FP_KEY);
  if (!fp) {
    fp = generateDeviceFp();
    sessionStorage.setItem(DEVICE_FP_KEY, fp);
  }
  return fp;
}

export function getTemToken() {
  const token = sessionStorage.getItem(TEM_TOKEN_KEY);
  if (!token || token === "undefined" || token === "null") {
    clearTemToken();
    return null;
  }
  return token;
}

export function clearTemToken() {
  sessionStorage.removeItem(TEM_TOKEN_KEY);
}

export function grantTemToken() {
  if (grantPromise) {
    debugTemAuth("reuse pending grant request");
    return grantPromise;
  }

  const deviceFp = getDeviceFp();
  debugTemAuth("grant token", { url: GRANT_URL, deviceFp });
  grantPromise = fetch(`${GRANT_URL}?deviceFp=${encodeURIComponent(deviceFp)}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    body: `deviceFp=${encodeURIComponent(deviceFp)}`
  })
    .then(async response => {
      const text = await response.text();
      const result = text ? JSON.parse(text) : {};

      if (!response.ok) {
        throw new Error(result.info || result.msg || response.statusText || "客户端信息校验失败");
      }

      return result;
    })
    .then(result => {
      const token = getTokenFromGrantResult(result);
      const isSuccess = token && SUCCESS_CODES.includes(getGrantResultCode(result));

      if (isSuccess) {
        sessionStorage.setItem(TEM_TOKEN_KEY, token);
        return token;
      }

      throw new Error(result.info || result.msg || "临时Token颁发失败");
    })
    .finally(() => {
      grantPromise = null;
    });

  return grantPromise;
}

function getGrantResultCode(result) {
  if (Object.prototype.hasOwnProperty.call(result, "result")) {
    return result.result;
  }
  return result.code;
}

function getTokenFromGrantResult(result) {
  const payload = result.data || result.content;

  if (typeof payload === "string") {
    return payload;
  }

  return payload && (payload.token || payload.temToken || payload.accessToken);
}

export async function ensureTemToken() {
  let token = getTemToken();
  if (!token) {
    token = await grantTemToken();
  } else {
    debugTemAuth("reuse cached token");
  }
  return token;
}

function debugTemAuth(message, extra) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[tem-auth] ${message}`, extra || "");
  }
}

export function getTemAuthApiPrefix() {
  return TEM_AUTH_API_PREFIX;
}

export function buildTemAuthHeaders(token) {
  return {
    "X-LSMYOA-Tem-Token": token,
    "X-LSMYOA-Device-Fp": getDeviceFp()
  };
}

export function isTemAuthSuccess(res) {
  if (res && (res.result === false || res.result === "false")) {
    return false;
  }

  return SUCCESS_CODES.includes(res && res.code);
}

export function isRetryableTemAuthError(error) {
  const responseData = error && error.response && error.response.data;
  const responseStatus = error && error.response && error.response.status;
  const message =
    (error && (error.info || error.msg || error.message)) ||
    (responseData && (responseData.info || responseData.msg || responseData.message)) ||
    "";

  return (
    isTemAuthInvalidResult(error) ||
    isTemAuthInvalidResult(responseData) ||
    RETRYABLE_KEYWORDS.some(keyword => message.includes(keyword)) ||
    EXTRA_RETRYABLE_KEYWORDS.some(keyword => message.includes(keyword)) ||
    responseStatus === 401 ||
    !!(error && (error.status === 401 || error.code === 401 || error.code === "401"))
  );
}

function isTemAuthInvalidResult(error) {
  if (!error) {
    return false;
  }

  return (
    (error.result === false || error.result === "false") &&
    (error.code === 0 || error.code === "0")
  );
}
